const AddWanted = ({setShowModal}: IAddWantedProps) => {
  return (
    <>
      <div className=" mx-2 bg-green-2 rounded-xl py-4 px-4 mt-8 ">
        <div className="flex justify-center w-full">
          <span className="icon-assessment bg-white rounded-full text-green-1 -mt-12  text-6xl"></span>
        </div>
        <p className=" text-gray-6 my-3 ">
          با ثبت درخواست ارزیابی، می‌توانید جهت مراجعه حضوری مشاور به محل آگهی
          برای ارزیابی کیفیت محصول، با کارشناسان ارتباط برقرار کنید.
        </p>
        <button
          className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
          id="open-btn"
          onClick={() => setShowModal(true)}
        >
          درخواست ارزیابی
        </button>
      </div>
    </>
  );
};

export default AddWanted;
